'use strict'
import React from 'react'
import PropTypes from 'prop-types'
import Slider from 'react-slick'
import { withTranslation as translate } from 'react-i18next'

class StoriesSlider extends React.PureComponent {
  render() {
    const _t = this.props.t
    // default settings
    let storiesSliderSettings = {
      dots: true,
      infinite: true,
      autoplay: false,
      swipeToSlide: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      useCss: true,
      className: 'stories-slider',
      dotsClass: 'stories-slider-dots',
      arrows: false
    }
    // populating settings
    storiesSliderSettings = Object.assign({}, storiesSliderSettings, this.props)
    return (
      <div className="stories-section-content-wrapper clearfix">
        <Slider {...storiesSliderSettings}>
          <div className="slide">
            <a
              href={`/content/tips-articles/podcast-the-wheelchair-tourist/`}
              className="stories-slider-item rome"
            >
              <img
                className="bg"
                src={require('../../images/home-page/wheelchairtourist.png')}
                alt="The Colosseum, Rome"
                title={_t('homepage_community_stories_travel_to_rome')}
              />
              <div className="stories-item-content">
                <div className="avatar-and-link-holder">
                  {/* <img
                    className="stories-item-content-avatar"
                    src={require('../../images/home-page/avatar-cory.jpg')}
                    alt="Cory Lee"
                    title="Cory Lee"
                  /> */}
                  <div className="stories-item-content-link">
                  Podcast: <br />The Wheelchair Tourist
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div className="slide">
            <a
              href={`/content/tips-articles/enjoying-accessible-london-autumn/`}
              className="stories-slider-item irina"
            >
              <img
                className="bg"
                src={require('../../images/home-page/londonlondon.jpg')}
                alt="Irina Martinez and friends"
                title={_t('homepage_community_stories_meet_irina')}
              />
              <div className="stories-item-content">
                <div className="avatar-and-link-holder">
                  <div className="stories-item-content-link">
                  Enjoy Accessible London In Autumn
                  </div>
                </div>
                <button className="stories-item-content-btn">
                  {_t('homepage_community_stories_get_inspired')}
                </button>
              </div>
            </a>
          </div>
          <div className="slide">
            <a
              href="/content/tips-articles/wheelchair-accessible-amsterdam/"
              className="stories-slider-item aron"
            >
              <img
                className="bg"
                src={require('../../images/home-page/amsterdam.jpg')}
                alt="Aron Andersson on desert road"
                title={_t('homepage_community_stories_meet_aron')}
              />
              <div className="stories-item-content">
                <div className="avatar-and-link-holder">
                  <div className="stories-item-content-link">
                  An Accessible Guide to Amsterdam:<br/> What to See and How to Get Around
                  </div>
                </div>
                <button className="stories-item-content-btn">
                  {_t('homepage_community_stories_empower')}
                </button>
              </div>
            </a>
          </div>
        </Slider>
      </div>
    )
  }
}

StoriesSlider.propTypes = {
  dots: PropTypes.bool,
  infinite: PropTypes.bool,
  autoplay: PropTypes.bool,
  swipeToSlide: PropTypes.bool,
  slidesToShow: PropTypes.number,
  slidesToScroll: PropTypes.number,
  useCss: PropTypes.bool,
  className: PropTypes.string,
  dotsClass: PropTypes.string,
  arrows: PropTypes.bool
}

export default translate()(StoriesSlider)
